// extracted by mini-css-extract-plugin
module.exports = {"textDivider":"index_textDivider_3Yq1y","textDividerContent":"index_textDividerContent_3iae7"};